var klaviyo = klaviyo || [];
klaviyo.init({
  account: window.klaviyoStrings.account_id,
  platform: "shopify",
  list: window.klaviyoStrings.list_id,
});
klaviyo.enable("backinstock", {
  trigger: {
    product_page_text: window.klaviyoStrings.product_page_text,
    product_page_class: "product-form__submit button button--full-width button--primary",
    product_page_text_align: "center",
    product_page_margin: "0px",
    alternate_anchor: "MainAddToCart",
    replace_anchor: false
  },
  modal: {
    headline: "{product_name}",
    body_content: window.klaviyoStrings.body_content,
    email_field_label: window.klaviyoStrings.email_field_label,
    newsletter_subscribe_label: window.klaviyoStrings.newsletter_subscribe_label,
    subscribe_checked: window.klaviyoStrings.subscribe_checked,
    button_label: window.klaviyoStrings.button_label,
    subscription_success_label: window.klaviyoStrings.subscription_success_label,
    footer_content: window.klaviyoStrings.footer_content,
    drop_background_color: window.klaviyoStrings.drop_background_color,
    background_color: window.klaviyoStrings.background_color,
    text_color: window.klaviyoStrings.text_color,
    button_text_color: window.klaviyoStrings.button_text_color,
    button_background_color: window.klaviyoStrings.button_background_color,
    close_button_color: window.klaviyoStrings.close_button_color,
    error_background_color: window.klaviyoStrings.error_background_color,
    error_text_color: window.klaviyoStrings.error_text_color,
    success_background_color: window.klaviyoStrings.success_background_color,
    success_text_color: window.klaviyoStrings.success_text_color
  }
});